import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  CircularProgress,
  LinearProgress,
  IconButton,
  InputAdornment,
  Grid,
  InputLabel,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import iconSearchs from "../../../../../src/assets/iconSearchs.svg"
import AddCircleIcon from "@mui/icons-material/AddCircle";
import docEnabled from 'assets/docEnabled.svg'
import docDisabled from 'assets/docDisabled.svg'
import uploadCloud from "assets/uploadCloud.svg";
import CrossRed from "assets/CrossRed.svg";
import './ImportList.css'; // Ensure you have appropriate styles
import { Navigate, useNavigate } from "react-router-dom";
import ImportService from "services/ImportService";
import dayjs from 'dayjs';
import { convertToLocalTime, debounceCustom } from "utils/CommonFunction";
import { convertDateString, formatDate } from "utils/utils";
import { SnackbarContext } from "context/snackBarContext";
import NoData from "assets/noData.svg";
import UnsupportedModal from "./UnsupportedModal";
import ConfirmModal from "./ConfirmModal";
import { AuthData } from "auth/AuthWarpper";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { format } from "date-fns";
import CustomPagination from "./CustomPagination";
import ImportStatusModal from "./ImportStatusModal";
import { useTranslation } from "react-i18next";
import dangerIcon from 'assets/danger.svg'
import successIcon from 'assets/successIcon.svg'
import failedIcon from 'assets/failedIcon.svg'
import Warning from 'assets/Warning.svg';
import TemplateDownloadModal from "./TemplateDownloadModal";
import {saveAs} from 'file-saver';

let setIlOriginalHEaderId = ''
let iconName = ""
let ImportStatusMessage = ""

let ImportStatusMessageSuccess = "Upload Successful"
let ImportStatusPartialFarmer = "Upload partially completed: - Kindly review the data log and import a new file as it can impact on farmers data"
let ImportStatusPartialContract = "Upload partially completed: - Kindly review the data log and import a new file as it can impact on farmers contract data"
let ImportStatusPartialHierarchy = "Upload partially completed:- Kindly review the data log and import a new file as it can impact on Hierarchy Structure"
let ImportStatusFailedContract = "Upload failed: - Kindly review the data log and import a new file as it can impact on farmers contract data"
let ImportStatusFailedFarmer = "Upload failed: - Kindly review the data log and import a new file as it can impact on farmers data"
let ImportStatusFailedHierarchy = "Upload Failed: - Kindly review the data log and import a new file as it can impact on Hierarchy Structure"


const ImportList = (props) => {
  const fileInputRef = useRef(null);
  const { t, i18n } = useTranslation()
  const { user } = AuthData();
  const navigate = useNavigate();
  const [showUpload, setShowUpload] = useState(false);
  const [importData, setImportData] = useState([
  ]);
  const [loading, setLoading] = useState(false);
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().subtract(6, 'month').startOf('day'));
  const [endDate, setEndDate] = useState(dayjs().endOf('day'));
  const [searchInput, setSearchInput] = React.useState(null);
  const [userInput, setUserInput] = useState('')
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20); // Number of items per page
  const [totalItems, setTotalItems] = useState(7); // Num
  const {
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);
  const [openModal, setOpenModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openTemplateDownloadModal, setOpenTemplateDownloadModal] = useState(false); // Add state for template download modal
  const [fileInputKey, setFileInputKey] = useState(Date.now()); // Unique key for resetting input
  const [comment, setComments] = useState("")
  const [cancelTokens, setCancelTokens] = useState({});
  const [pollingIntervals, setPollingIntervals] = useState({});
  // Define min and max dates for the pickers
  const minDate = dayjs().subtract(6, 'month').startOf('day');
  const maxDate = dayjs().endOf('day');
  const [progresses, setProgresses] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const[iconLoaded,setIconLoaded]=useState(false)
   
  useEffect(() => {
    callListAPI(currentPage, itemsPerPage);
  }, [])

  useEffect(() => {
    // Update end date if it becomes earlier than start date
    if (endDate.isBefore(startDate)) {
      setEndDate(startDate);
    }
    setCurrentPage(0)
    callListAPI(0, itemsPerPage, searchInput)
  }, [startDate, endDate]);

  const callListAPI = ((pNumber, size, searchquery) => {
    let sDate = dayjs(startDate).format('DD-MM-YYYY')
    let eDate = dayjs(endDate).format('DD-MM-YYYY')
    setLoading(true)
    ImportService.FetchImportList({ entityName: props?.entityName, startDate: sDate, endDate: eDate, pageNumber: pNumber, size: size, searchquery })
      .then(res => {
        let resp = res?.data?.response;
        setImportData(resp?.importLogHeader)
        setCurrentPage(pNumber)
        setItemsPerPage(size)
        setTotalItems(res?.data?.response?.totalItems)
        setLoading(false)

      })
      .catch(error => {
        setImportData([])
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setLoading(false)
      });
  })
  const callImportStatusAPI = ((IlHeaderId) => {
    setLoading(true)
    let apiName = ''
        if (props?.entityName == 'ImportFarmer') {
          apiName = 'farmer-import'
        }   
        if (props?.entityName == 'ImportHierarchy') {
          apiName ='hierarchy-import'
        }
        if (props?.entityName == 'ImportContract') {
          apiName ='import-contract'
        }
        ImportService.fetchImportStatusAPI({ entityName: apiName, IlHeaderId: IlHeaderId })
      .then(res => {
        let resp = res?.data?.response;
        setLoading(false)
        if (props?.entityName == 'ImportFarmer') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedFarmer
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialFarmer
          }
        }
        if (props?.entityName == 'ImportHierarchy') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedHierarchy
          }
          else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialHierarchy
          }
        }
        if (props?.entityName == 'ImportContract') {
          if (resp == "Upload Failed") {
            iconName = failedIcon
            ImportStatusMessage = ImportStatusFailedContract
          }
         else if (resp == "Upload Successful") {
            iconName = successIcon
            ImportStatusMessage = ImportStatusMessageSuccess
          }
          else if (resp == "Partial Upload Successful") {
            iconName = dangerIcon
            ImportStatusMessage = ImportStatusPartialContract
          }
        }
       const img = new Image();
      img.src = iconName;
      img.onload = () => {
        setIconLoaded(true);
        setOpenStatusModal(true);
      };
      })
      .catch(error => {
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setLoading(false)
      });
  })
  const onSearch = useCallback(
    debounceCustom((searchquery, pageSize) => {
      setSearchInput(searchquery)
      if (searchquery != "") {
        const params = new URLSearchParams();
        params.append('userInput', searchquery)
        setUserInput(searchquery);
        callListAPI(0, pageSize, searchquery)
      } else {
        callListAPI(0, pageSize)
      }
    }, 1000)
  );
  const getStatusColor = (status) => {
    switch (status) {
      case 'Upload Successful':
        return 'green';
      case 'Upload Failed':
        return 'red';
      case 'Upload Cancelled':
        return 'red';
      case 'InProgress':
        return 'green';
      case 'Partial Upload Successful':
        return '#F2BB40';
      default:
        return 'black';
    }
  };
  const handleEntityRedirect = (id) => {
    if (props?.entityName == "Farmer") {
      Navigate('/')
    } else if (props?.entutyName == "Hierarchy") {
      Navigate('/')
    } else {
      Navigate('/')
    }
  }

  const handleViewLog = (id, additionalData) => {
    let routeName = ''
    if (props?.entityName == "ImportFarmer") {
      routeName = 'viewFarmerLog'
    } else if (props?.entityName == "ImportContract") {
      routeName = 'viewContractLog'
    } else {
      routeName = 'viewHierarchyLog'
    }
    navigate(`/${routeName}/${id}`, { state: additionalData });
  };

  
  const handleDownloadTemplate = async (e, isTemplate) => {
    e.preventDefault();
    
    // If it's a template download, show the modal first
    if (isTemplate && (props?.entityName == 'ImportContract')) {
      setOpenTemplateDownloadModal(true);
      return;
    }
    
    // If it's not a template (user guide), download directly
    await performDownload(isTemplate);
  };

  const performDownload = async (isTemplate) => {
    let entity = ''
    if (props?.entityName == 'ImportFarmer') {
      entity = 'farmer'
    }
    if (props?.entityName == 'ImportHierarchy') {
      entity = 'hierarchy'
    }
    if (props?.entityName == 'ImportContract') {
      entity = 'contract'
    }
    if(!isTemplate){
         downloadExcelFile(entity ,isTemplate)
         return
    }

    try {
      const response = await ImportService.DownloadFile({ name: entity, isTemplate: isTemplate }, {
        responseType: 'text' // Expecting the response as plain text (CSV content)
      });
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      let fileName = "File"
      const contentDisposition = response.headers.get('Content-Disposition');
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
        const filename = filenameMatch && filenameMatch[1];
        if (filename) {
          fileName = filename
        }
      }
      const fileContent = response.data;
      // Create a Blob from the text content
      const blob = new Blob([fileContent], { type: 'text/csv' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };


  const downloadExcelFile = async (entity,isTemplate) => {
    try {
      const response = await ImportService.DownloadExcelFile({ name: entity, isTemplate: isTemplate }, {});
      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }
      const disposition = response.headers['content-disposition'];
      const filename =
        disposition?.split('filename=')[1]?.replace(/"/g, '') || 'download.xlsx';
      saveAs(response.data, filename);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  
  // Handler for template download modal confirmation
  const handleTemplateDownloadConfirm = () => {
    setOpenTemplateDownloadModal(false);
    performDownload(true); // Download the template
  };


  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const paginate = (pageNumber, itemsPerPage) => {
    callListAPI(pageNumber - 1, itemsPerPage, searchInput)
  }
  ///handle file uploads 

  const handleBackButton = () => {
    callListAPI(0, itemsPerPage)
    setShowUpload(false)
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file && !file.name.endsWith('.csv')) {
        setOpenModal(true);
      } else {
        setFileInputKey(Date.now()); // Reset input field
        callUploadAPI(file)
      }
    }
  };
  const clearFileInput = () => {
    setOpenModal(false)
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  const callUploadAPI = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('username', user?.userName);
    setLoading(true)

    let importTime = format(new Date(), "HH:mm:ss");
    let importDate = format(new Date(), "yyyy-MM-dd");


    ImportService.UploadFile({ entityName: props?.entityName, comment: comment, username: user?.userName, file: formData, importDate: importDate, importTime: importTime })
      .then(res => {
        let resp = res?.data?.response;
        setLoading(false)
        callStartProcess(resp)
      })
      .catch(error => {
        callListAPI(0, itemsPerPage)
        setShowUpload(false)
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setLoading(false)
      });
  }

  const callStartProcess = (data) => {
    let callAPIPRomise = ''
    if (props?.entityName == 'ImportFarmer') {
      callAPIPRomise = ImportService.UploadStartProcess(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportHierarchy') {
      callAPIPRomise = ImportService.ImportHierarchyProcessStart(data?.ilHeaderId)
    }
    if (props?.entityName == 'ImportContract') {
      callAPIPRomise = ImportService.ImportContractProcessStart(data?.ilHeaderId)
    }
    // ImportService.ImportHierarchyProcessStart(data?.ilHeaderId)
    callAPIPRomise.then(res => {
      let resp = res?.data?.response;
      setLoading(false)
      setShowUpload(false)

      if(props?.entityName == "ImportHierarchy"){
        setTimeout(() => {
          callListAPI(0, itemsPerPage)
          }, 1000);
      }else{
        callListAPI(0, itemsPerPage)
      }
    })
      .catch(error => {
        setShowUpload(false);
        callListAPI(currentPage, itemsPerPage);
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setLoading(false)
      });
  }

  const handleCancelClick = (id) => {
    setSelectedFile(id);
    setOpenCancelModal(true);
  };


  const callancelProgress = (id) => {
    ImportService.ImportHierarchyLogCancel({ id })
      .then(res => {
        let resp = res?.data?.response;
        setLoading(false)
        callListAPI(currentPage, itemsPerPage);
      })
      .catch(error => {
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        setLoading(false)
      });
  }
  const handleCancelConfirm = () => {
    setOpenCancelModal(false)
    if (selectedFile) {
      let callAPIPRomise = ''
      if (props?.entityName == 'ImportFarmer') {
        callAPIPRomise = ImportService.UploadCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportHierarchy') {
        callAPIPRomise = ImportService.ImportHierarchyLogCancel({ id: selectedFile })
      }
      if (props?.entityName == 'ImportContract') {
        callAPIPRomise = ImportService.ImportContractLogCancel({ id: selectedFile })
      }

      // ImportService.ImportHierarchyLogCancel({ id: selectedFile })
      callAPIPRomise.then(res => {
        setLoading(false)
        callListAPI(currentPage, itemsPerPage);
      })
        .catch(error => {
          callListAPI(currentPage, itemsPerPage);
          setMessage(error?.response?.data?.message || error?.message)
          setOpenAlert(true)
          setSeverity("error")
          setLoading(false)
        });
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      importData.forEach(row => {
        if (row.uploadStatus.includes('InProgress')) {
          let callAPIPRomise = ''
          if (props?.entityName == 'ImportFarmer') {
            callAPIPRomise = ImportService.UploadProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportHierarchy') {
            callAPIPRomise = ImportService.GetImportHierarchyLogProgress(row?.ilHeaderId)
          }
          if (props?.entityName == 'ImportContract') {
            callAPIPRomise = ImportService.GetImportContractLogProgress(row?.ilHeaderId)
          }

          // ImportService.GetImportHierarchyLogProgress(row?.ilHeaderId)
          callAPIPRomise.then(progress => {
            if (progress !== null) {
              let p = progress?.data?.response
              if (p == 100) {
                callListAPI(currentPage, itemsPerPage);
                setTimeout(() => {
                  if (setIlOriginalHEaderId != row?.ilHeaderId) {
                    callImportStatusAPI(row?.ilHeaderId)
                  }
                  setIlOriginalHEaderId = row?.ilHeaderId
                }, 10)
                return
              }
              setProgresses(prev => ({
                ...prev,
                [row.ilHeaderId]: p

              }));
            }
          });
        }
      });
    }, 1000); // Poll every second
    // Clean up interval on component unmount or when importData changes
    return () => clearInterval(intervalId);
  }, [importData]);

  function formatNumber(num) {
    return String(num).padStart(2, '0');
  }


  const setColor = (status) => {
    switch (status) {
      case 'Upload Failed':
        return '#BABBC1';
      case 'InProgress':
        return '#BABBC1';
      default:
        return 'black';
    }
  };
  return (
    <>
      {showUpload ? (
        <div>
          <Grid container sx={{ display: "flex", justifyContent: 'space-between' }} >
            <Grid
              md={7}
              lg={7}
              sm={8}
              xs={12}
            >

              <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                <InputLabel sx={{ width: "8rem", marginTop: "10px", alignSelf: "flex-start" }} htmlFor="my-input">
                  Comments
                </InputLabel>
                <TextField
                  disabled={loading}
                  onChange={(e) => setComments(e.target.value)}
                  placeholder="Type here"
                  autoFocus
                  sx={{
                    width: "100%",
                    fontStyle: "italic"
                  }}
                  multiline
                  minRows={3}
                />
              </Box>
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2,
                }}
              >
                <Button
                  sx={{
                    borderRadius: 100,
                    minWidth: 95,
                    minHeight: 44,
                    background: "#102A62",
                  }}
                  disabled={loading}
                  variant="contained"
                  startIcon={<KeyboardBackspaceIcon />}
                  onClick={handleBackButton}
                >
                  Back
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid container sx={{ paddingTop: "2rem" }}>
            <Grid
              md={4}
              lg={3}
              sm={5}
              xs={12}
              sx={{ cursor: "pointer" }}
            >
              <input
                style={{ display: "none" }}
                id="contained-button-file"
                type="file"
                // multiple
                // accept=".csv"
                ref={fileInputRef}
                onChange={(e) => handleFileChange(e)}
                disabled={loading}
              />
              <label htmlFor="contained-button-file">
                <Box
                  sx={{
                    backgroundColor: "#F2F6FF",
                    cursor: "pointer",
                    display: "flex",
                    padding: "20px",
                    justifyContent: "space-evenly",
                    borderRadius: "10px", // Fix here
                    height: "88px",
                    minWidth: { sm: "unset", md: "360px" },
                    alignItems: "center",
                    backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='27' ry='27' stroke='rgba(126, 176, 236, 1)' stroke-width='3' stroke-dasharray='20' stroke-dashoffset='8' stroke-linecap='square'/%3e%3c/svg%3e")`, // Use backticks for template literals
                    borderRadius: "27px" // Keep in camelCase
                  }}
                >
                  <img src={uploadCloud} width="87.51px" height="" />
                  <Box
                    sx={{
                      borderRadius: 4,
                      width: 120,
                      minHeight: 50,
                      maxHeight: 54,
                      backgroundColor: loading ? 'rgba(0, 0, 0, 0.12)' : '#EF7D00',
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      verticalAlign: "center",
                      cursor: "pointer",
                      textAlign: "center",
                      "&:hover": {
                      },
                      "&:active": {
                      },
                    }}
                  >
                    {loading && <CircularProgress sx={{ position: "absolute" }} size={15} />}
                    IMPORT
                  </Box>

                </Box>

              </label>
            </Grid>
          </Grid>
          <Box sx={{ paddingTop: "20px", gap: 2, display: "flex", flexDirection: "column" }}>
            <Box>
              Import User Guide - <a onClick={(e) => handleDownloadTemplate(e, false)} href="javascript:void(0)" style={{ color: '#1CB9ED', textDecoration: 'underline' }}>Download</a>
            </Box>
            <Box>
              Import Template - <a onClick={(e) => handleDownloadTemplate(e, true)} href="javascript:void(0)" style={{ color: '#1CB9ED', textDecoration: 'underline' }}>Download</a>
            </Box>
          </Box>
         <UnsupportedModal openModal={openModal} closeOpenModal={() => clearFileInput()} />
           <TemplateDownloadModal
            open={openTemplateDownloadModal} 
            onClose={() => setOpenTemplateDownloadModal(false)}
            onConfirm={handleTemplateDownloadConfirm}
          /> 
        </div>
      ) : (
        <>
          <Box sx={{ paddingBottom: "140px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: 600,
                fontSize: "1.25rem",
                color: "rgba(115, 125, 134, 1)",
              }}>
                {props?.displayName}
              </Box>
              <Box>
                <Button
                  sx={{
                    borderRadius: 100,
                    minWidth: 95,
                    minHeight: 44,
                    background: "#102A62",
                  }}
                  variant="contained"
                  startIcon={<AddCircleIcon />}
                  onClick={() => setShowUpload(true)}
                >
                  Import
                </Button>
              </Box>
            </Box>
            <Box sx={{ paddingTop: "20px", display: "flex", gap: 4, flexDirection: { xs: "column", sm: "row" } }}>
              <Box>
                <Typography sx={{ color: "rgba(115, 125, 134, 1)", padding: "10px" }}>
                  Initial Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{
                      '& .MuiInputBase-formControl': {
                        backgroundColor: "#F5F5F7 !important", fontWeight: 700,
                        border: "none !important"
                      },
                      borderRadius: "12px",
                      boxShadow: '0px 2px 6px -2px #B9B9B9',
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important"  // This removes the border
                      }
                    }}
                    id="startDate"
                    name="startDate"
                    open={startDateOpen}
                    onClose={() => setStartDateOpen(false)}
                    format="DD/MM/YYYY"
                    value={startDate}
                    onChange={(newValue) => {
                      setStartDate(newValue);
                      if (endDate.isBefore(newValue)) {
                        setEndDate(newValue);
                      }
                    }}
                    minDate={minDate}
                    maxDate={endDate}
                    renderInput={(params) => <TextField variant="standard" {...params} />}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: { variant: 'standard' },
                      textField: {
                        onClick: () => setStartDateOpen(true),
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box>
                <Typography sx={{ color: "rgba(115, 125, 134, 1)", padding: "10px" }}>
                  End Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{
                      '& .MuiInputBase-formControl': {
                        backgroundColor: "#F5F5F7 !important", fontWeight: 700,
                        borderRadius: "12px",
                        boxShadow: '0px 2px 6px -2px #B9B9B9',
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none !important"  // This removes the border
                        }
                      }
                    }}
                    id="endDate"
                    name="endDate"
                    open={endDateOpen}
                    onClose={() => setEndDateOpen(false)}
                    format="DD/MM/YYYY"
                    value={endDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                      if (newValue.isBefore(startDate)) {
                        setStartDate(newValue);
                      }
                    }}
                    minDate={startDate}
                    maxDate={maxDate}
                    renderInput={(params) => <TextField  {...params} />}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                      textField: {
                        onClick: () => setEndDateOpen(true),
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ minWidth: "321px", marginLeft: { sm: "auto" }, display: "flex", alignItems: "flex-end" }}>
                <TextField fullWidth className="user-search-input"
                  placeholder="Search" variant="outlined"
                  onChange={(event) => onSearch(event.target.value, itemsPerPage)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {loading && <CircularProgress size={15} />}
                        <img src={iconSearchs} />
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: "30px",
                      fontStyle: "italic",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important"  // This removes the border
                      }
                    }
                  }}
                />
              </Box>
            </Box>
            {importData?.length > 0 &&
              <div className="import-table-container" style={{ paddingTop: "20px" }}>
                <table className="import-table">
                  <thead>
                    <tr className="HierarchyHead">
                      <th>Date</th>
                      <th>File Name</th>
                      <th>Upload By User</th>
                      <th>Upload Status</th>
                      <th>Comments</th>
                      <th>Timestamp</th>
                      <th>Total Records</th>
                      <th>Success</th>
                      <th>Failed</th>
                      <th>View Log</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importData.map((row, index) => (
                      <tr key={index} className="import-table-row">
                        <td>{convertDateString(row?.importDate)}</td>
                        <td>{row.fileName}</td>
                        <td>{row.uploadedBy
                        }</td>
                        <td style={{ color: getStatusColor(row?.uploadStatus) }}>
                          {row?.uploadStatus?.includes('InProgress') && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <LinearProgress
                                sx={{
                                  width: '100%', marginRight: 1, height: 10, minWidth: '30px',
                                  borderRadius: '10px', // Border radius
                                  '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#4caf50', // Color of the filled portion (green)
                                  },
                                  '& .MuiLinearProgress-root': {
                                    backgroundColor: 'yellow !important', // Color of the unfilled portion (grey)
                                  },
                                }}
                                variant="determinate"
                                value={progresses[row.ilHeaderId] || 0}
                              />
                              <Box sx={{ boxShadow: '0px 2px 5px 2px #B9B9B9', fontSize: "8px", fontWeight: 600, textAlign: "center", borderRadius: "10px", padding: "5px", minWidth: "25px" }}>{progresses[row.ilHeaderId]}%</Box>
                              <IconButton
                                onClick={() => handleCancelClick(row?.ilHeaderId)}
                                size="small"
                              >
                                <img src={CrossRed} />
                              </IconButton>
                            </Box>
                          )}
                          {!row?.uploadStatus?.includes('InProgress') && row.uploadStatus}
                        </td>
                        <td>{row.comments}</td>
                        <td> {row.importTime}</td>
                        <td> {formatNumber(Number(row.totalRecordCount))}</td>
                        <td style={{ color: setColor(row?.uploadStatus) }}>  {formatNumber(Number(row.successRecordCount))}</td>
                        <td style={{ color: setColor(row?.uploadStatus) }}> {formatNumber(Number(row.failedRecordCount))}</td>
                        <td>
                          {(row?.uploadStatus?.includes('InProgress') || row?.totalRecordCount == 0) ?
                            <p> <img style={{ cursor: "pointer" }} src={docDisabled} /></p>
                            :
                            <p onClick={() => handleViewLog(row.ilHeaderId, {
                              fileName: row.fileName,
                              uploadedBy: row.uploadedBy,
                              uploadStatus: row.uploadStatus,
                              comments: row.comments,
                              timestamp:row.importTime,
                              totalRecords: row.totalRecordCount,
                              success: row.successRecordCount,
                              fail: row.failedRecordCount
                            })} ><img style={{ cursor: "pointer" }} src={docEnabled} /></p>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <ImportStatusModal icon={iconName} message={ImportStatusMessage} open={openStatusModal && iconLoaded} onClose={() => {
      setOpenStatusModal(false);
      setIconLoaded(false); 
    }} />
                <ConfirmModal open={openCancelModal} onClose={() => setOpenCancelModal(false)} handleCancelConfirm={() => handleCancelConfirm()} />
              </div>
            }
            {importData?.length == 0 &&
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "40px"
                }}
              >
                <img src={NoData} style={{ height: "100px" }} alt="No Data" />
                <p>No Data Available</p>
              </Box>}
          </Box>
          {importData?.length > 0 &&
            <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
              {importData &&
                <CustomPagination
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={(v) => setItemsPerPage(v)}
                  totalItems={totalItems}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              }
            </div>
          }
        </>
      )}
    </>
  );
};

export default ImportList;
